// ======================================================================
// File Name       : InitialImageConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ModalIds from './ModalIds';

export const INITIAL_IMAGE = {
  IMAGE_SYSTEMS: 0,
  IMAGE_SELECTION: 1,
};

export const IMAGE_TYPE_INT = {
  COURSE: 0,
  BOX: 1,
  DRILL: 2,
  TEST: 3,
  REPORT: 4,
  LINK: 5,
  LIVE: 6,
};

export const ITEM_IMAGE_TYPE = {
  COURSE: 0,
  BOX: 1,
  DRILL: 2,
  TEST: 3,
  REPORT: 4,
  ADAPTIVE: 5,
  LINK: 6,
};

export const TITLE_OBJ_STR = {
  COURSE: 'コース',
  BOX: 'セクション',
  DRILL: 'ドリル',
  TEST: 'テスト',
  REPORT: 'レポート',
  LINK: 'リンク',
};

export const TITLE_OBJ = {
  COURSE: 'COURSE',
  BOX: 'BOX',
  DRILL: 'DRILL',
  TEST: 'TEST',
  REPORT: 'REPORT',
  LINK: 'LINK',
};

export const DEFAULT_THUMBNAIL = [
    { name: 'course_thumbnail.png', value: 0 },
    { name: 'box_thumbnail.png', value: 1 },
    { name: 'item_drill_normalmode_thumbnail.png', value: 2 },
    { name: 'item_drill_testmode_thumbnail.png', value: 3 },
    { name: 'item_drill_reportmode_thumbnail.png', value: 4 },
    { name: 'item_link_thumbnail.png', value: 6 },
];
